import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class WalletCustomFieldsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('purchases/wallet')) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && Array.isArray(event.body)) {
          return event.clone({
            body: event.body.map(item => ({
              ...item,
              CustomFields: item.CustomFields ?? [],
            })),
          });
        }
        return event;
      })
    );
  }
}
